<template>
  <div>
    <v-menu
      v-if="!notificationsOnly"
      bottom
      left
      v-model="dialogMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex align-center">
          <v-btn
            class="mr-2 button"
            outlined
            large
            :disabled="!!event && !eventExclusive"
            v-bind="attrs"
            v-on="on"
            @click="openMenuEvent()"
          >
            <v-icon size="20" class="mr-1">mdi-account-multiple</v-icon>
            <span class="button-text text-capitalize"
              >Seleccionar audiencia</span
            >
          </v-btn>
        </div>
      </template>
      <v-card class="pa-4 audience-menu-card" color="white" width="400">
        <v-row class="ma-0 mb-3 audience-menu-header" justify="space-between" align="center">
          <v-btn class="mr-2" outlined small @click="setRules([], undefined, {}, true)">
            <span class="filter-button">Borrar</span>
          </v-btn>

          <span class="mr-2 font-weight-bold audience-menu-title">Categorías</span>
          <v-btn class="mr-2" small color="#1b273e" @click="closeMenu()">
            <span class="filter-button white--text">Listo</span>
          </v-btn>
        </v-row>

        <v-divider class="mb-2" />
        <v-row class="ma-0 audience-categories">
          <v-expansion-panels accordion elevation="0">
            <v-expansion-panel
              class="filter-item audience-category"
              cols="12"
              elevation="0"
              v-for="(rule, index) in getRuleCategories"
              :key="`${rule}-${index}`"
            >
              <v-expansion-panel-header class="header-auto px-2 py-1">
                <span
                  v-if="isExclusiveEventMode"
                  class="black--text wc-caption-2"
                >{{ labels[rule] }}</span>
                <v-checkbox
                  v-else
                  hide-details
                  class="shrink"
                  dense
                  multiple
                  color="#1b273e"
                  :label="rule"
                  :value="rule"
                  v-model="rules_category_selected"
                  @change="includeAllRuleOptions(rule)"
                  @click.stop
                >
                  <template v-slot:label>
                    <span class="black--text wc-caption-2">{{
                      labels[rule]
                    }}</span>
                  </template>
                </v-checkbox>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="px-2">
                <v-row class="ma-0 pt-1 audience-options">
                  <v-col v-if="isExclusiveEventMode" class="py-1 filter-item" cols="12">
                    <v-checkbox
                      hide-details
                      class="shrink"
                      dense
                      color="#1b273e"
                      :input-value="isCategoryAll(rule)"
                      label="Todos"
                      @change="toggleCategoryAll(rule, $event)"
                    >
                      <template v-slot:label>
                        <span class="black--text wc-caption-2">Todos</span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col
                    class="py-1 filter-item audience-option"
                    cols="12"
                    v-for="(option, index) in getRuleDefaultValues(rule)"
                    :key="`${option}-${index}`"
                  >
                    <v-checkbox
                      hide-details
                      class="shrink"
                      dense
                      multiple
                      color="#1b273e"
                      v-model="rules_selected[rule]"
                      :label="option.name"
                      :value="option._id"
                      @change="onOptionChange(rule)"
                    >
                      <template v-slot:label>
                        <span class="black--text wc-caption-2">{{
                          option.name
                        }}</span>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-card>
    </v-menu>
    <v-checkbox
      v-if="!disableNotifications"
      v-model="setNotificationsEnabled"
      :label="getCategoryLabel"
    >
    </v-checkbox>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex/dist/vuex.common.js';

export default {
  props: {
    benefit: String,
    event: String,
    eventExclusive: {
      type: Boolean,
      default: false,
    },
    publication: String,
    productService: String,
    editMode: {
      type: Boolean,
      default: false,
    },
    savedRules: {
      type: Object,
      default: undefined,
    },
    hideBranches: {
      type: Boolean,
      default: false,
    },
    disableNotifications: {
      type: Boolean,
      default: false,
    },
    notificationsOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogMenu: false,
      setNotificationsEnabled: false,
      labels: {
        affiliationTypes: 'Tipo de membresía',
        branches: 'Secciones locales',
        memberStatus: 'Estatus de miembros',
        subgroups: 'Subgrupos',
      },
      rules_default: {},
      rules_category_selected: [],
      rules_selected: {
        affiliationTypes: [],
        branches: [],
        subgroups: [],
        memberStatus: [],
      },
      rules_all_categories: {
        affiliationTypes: false,
        branches: false,
        subgroups: false,
        memberStatus: false,
      },
      rulesCatalogReady: false,
      rulesCatalogPromise: null,
      hasLoadedSavedRules: false,
      rulesTouched: false,
    };
  },
  watch: {
    benefit(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetSelectionState();
      }
    },
    savedRules(newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.hasLoadedSavedRules = false;
      }
    },
    disableNotifications: {
      immediate: true,
      handler(val) {
        if (val) this.setNotificationsEnabled = false;
      },
    },
    rules_selected: {
      deep: true,
      handler(val) {
        this.emitRulesChange(val);
      },
    },
  },
  computed: {
    ...mapState('audienceRules', ['audience_rules']),
    getRuleCategories() {
      const keys = ['memberStatus', 'affiliationTypes', 'branches', 'subgroups']
        .filter((key) => Object.prototype.hasOwnProperty.call(this.rules_default, key));
      if (this.hideBranches) {
        return keys.filter((key) => key !== 'branches');
      }
      return keys;
    },
    isExclusiveEventMode() {
      return !!this.event && this.eventExclusive === true;
    },
    getCategoryLabel() {
      const baseLabel = `Enviar notificación para los miembros en las categorías de `
      const { benefit, event, publication, productService } = this.$props;
      const labels = {
        benefit: 'este beneficio',
        event: 'este evento',
        publication: 'esta publicación',
        productService: 'este producto',
      };
      const matchingCategory = Object.entries({ benefit, event, publication, productService }).find(
        ([key, value]) => !!value
      );
      const labelKey = matchingCategory ? matchingCategory[0] : null;
      return labels[labelKey] ? baseLabel + labels[labelKey] : 'Enviar notificación';
    },
  },
  methods: {
    ...mapActions('audienceRules', [
      'fetchOrganizationAudienceRules',
      'getAudienceRuleByCategoryId',
      'createAudienceRules',
      'updateAudienceRule',
      'sendEmailsByAudienceRule',
    ]),
    ...mapMutations('notification', ['show']),

    emitRulesChange(selected = this.rules_selected) {
      const payload = { ...selected };
      if (this.isExclusiveEventMode) {
        payload.allCategories = { ...this.rules_all_categories };
      }
      this.$emit('change', payload);
    },

    isCategoryAll(key) {
      return this.rules_all_categories[key] === true;
    },

    normalizeRules(selectedRules = {}) {
      const categories = ['memberStatus', 'affiliationTypes', 'branches', 'subgroups'];
      return categories.reduce((result, key) => {
        result[key] = Array.isArray(selectedRules[key]) ? [...selectedRules[key]] : [];
        return result;
      }, {});
    },

    normalizeAllCategories(allCategories = {}) {
      const categories = ['memberStatus', 'affiliationTypes', 'branches', 'subgroups'];
      return categories.reduce((result, key) => {
        result[key] = allCategories[key] === true;
        return result;
      }, {});
    },

    getSelectedAllCategories() {
      return this.hideBranches
        ? Object.fromEntries(
            Object.entries(this.rules_all_categories).filter(([key]) => key !== 'branches'),
          )
        : { ...this.rules_all_categories };
    },

    categoryIsFullySelected(key, selectedRules = this.rules_selected) {
      const options = this.getRuleDefaultValues(key);
      const selected = selectedRules[key] || [];
      return options.length === selected.length
        && options.every(option => selected.includes(option._id));
    },

    async ensureRulesCatalogReady() {
      if (this.rulesCatalogReady) return;

      if (!this.rulesCatalogPromise) {
        this.rulesCatalogPromise = (async () => {
          await this.getAudienceRules();
          this.rules_default = this.normalizeRuleCatalog(this.audience_rules);
          this.rulesCatalogReady = true;
        })();
      }

      await this.rulesCatalogPromise;
    },

    normalizeRuleCatalog(rules = {}) {
      const categories = ['memberStatus', 'affiliationTypes', 'branches', 'subgroups'];
      return categories.reduce((result, key) => {
        result[key] = Array.isArray(rules[key]) ? [...rules[key]] : [];
        return result;
      }, {});
    },

    resetSelectionState() {
      this.hasLoadedSavedRules = false;
      this.setRules();
    },

    initializeExclusiveRules() {
      const selectedRules = this.normalizeRules();
      const allCategories = this.normalizeAllCategories();
      this.getRuleCategories.forEach((key) => {
        selectedRules[key] = this.getRuleDefaultValues(key).map(rule => rule._id);
        allCategories[key] = true;
      });
      this.setRules([], selectedRules, allCategories, true);
    },

    async getAudienceRules() {
      try {
        await this.fetchOrganizationAudienceRules();
      } catch (error) {
        console.log(error);
      }
    },

    includeAllRuleOptions(key = null) {
      if (!key) return;
      this.rulesTouched = true;
      if (![...this.rules_category_selected].includes(key)) {
        this.rules_selected[key] = [];
      } else {
        this.rules_selected[key] = this.rules_default[key].map(
          (rule) => rule._id
        );
      }
    },

    toggleCategoryAll(key, checked) {
      this.$set(this.rules_all_categories, key, checked === true);
      this.$set(
        this.rules_selected,
        key,
        checked === true ? this.getRuleDefaultValues(key).map(rule => rule._id) : [],
      );
      this.rulesTouched = true;
      this.emitRulesChange();
    },

    onOptionChange(key) {
      this.rulesTouched = true;
      if (!this.isExclusiveEventMode) return;
      this.$set(this.rules_all_categories, key, this.categoryIsFullySelected(key));
      this.emitRulesChange();
    },

    getRuleDefaultValues(key = null) {
      if (!key) return [];
      return Array.isArray(this.rules_default[key]) ? this.rules_default[key] : [];
    },

    setRules(
      selected_category = [],
      selected_rules = {
        affiliationTypes: [],
        branches: [],
        subgroups: [],
        memberStatus: [],
      },
      allCategories = {},
      touched = false,
    ) {
      this.rules_category_selected = [...selected_category];
      this.rules_selected = this.normalizeRules(selected_rules);
      this.rules_all_categories = this.normalizeAllCategories(allCategories);
      this.rulesTouched = touched;
      this.emitRulesChange();
    },

    async createRules({ benefit = null, event = null, publication = null, productService = null }) {
      try {
        const payload = {
          benefit: benefit,
          event: event,
          publication: publication,
          productService: productService,
        };
        const selectedRules = this.hideBranches
          ? Object.fromEntries(
              Object.entries(this.rules_selected).filter(([key]) => key !== 'branches')
            )
          : this.rules_selected;
        if (!event && (benefit || publication) && !this.rulesTouched
          && Object.values(selectedRules).every(values => values.length === 0)) {
          selectedRules.memberStatus = ['ACTIVE'];
        }
        const response = await this.createAudienceRules({
          ...payload,
          ...selectedRules,
          ...(this.isExclusiveEventMode ? { allCategories: this.getSelectedAllCategories() } : {}),
        });
        if (response.status) {
          this.rulesTouched = false;
          if (!this.disableNotifications && this.setNotificationsEnabled) await this.sendEmails();
        }
        return response;
      } catch (error) {
        return { status: false, message: error.message };
      } finally {
        this.dialogMenu = false;
      }
    },

    async updateRules({ benefit = null, event = null, publication = null, productService = null }) {
      if (!this.rulesTouched) {
        return { status: true, unchanged: true };
      }

      try {
        const categories = {
          benefit: benefit,
          event: event,
          publication: publication,
          productService: productService,
        };
        const selectedRules = this.hideBranches
          ? Object.fromEntries(
              Object.entries(this.rules_selected).filter(([key]) => key !== 'branches')
            )
          : this.rules_selected;
        const response = await this.updateAudienceRule({
          categoryId: this.getCurrentCategoryId(categories),
          payload: {
            ...categories,
            ...selectedRules,
            ...(this.isExclusiveEventMode ? { allCategories: this.getSelectedAllCategories() } : {}),
          },
        });

        if (!response || !response.status) {
          throw new Error(response && response.message ? response.message : 'No se pudo guardar la audiencia');
        }

        this.rulesTouched = false;
        if (!this.disableNotifications && this.setNotificationsEnabled) await this.sendEmails();
        return response;
      } catch (error) {
        this.show({
          text: 'No se pudo guardar la segmentación de audiencia.',
          color: 'error',
        });
        return { status: false, message: error.message };
      } finally {
        this.dialogMenu = false;
      }
    },

    async saveRules(categories = {}) {
      const categoryId = this.getCurrentCategoryId(categories);
      if (!categoryId) return { status: false };
      const { status } = await this.getAudienceRuleByCategoryId(categoryId);
      if (status) {
        return await this.updateRules(categories);
      }
      return await this.createRules(categories);
    },

    async sendEmails() {
      try {
        const categoryId = this.getCurrentCategoryId(this.$props);
        const response = await this.sendEmailsByAudienceRule(categoryId);

        if(response.status) {
          this.show({
            color: "success",
            text: "Notificaciones enviadas con éxito.",
          });
        }
      } catch (error) {
        this.show({
          text: 'Error al enviar notificaciones',
          color: 'error',
        });
      }
    },

    closeMenu() {
      this.dialogMenu = false;
    },

    getCurrentCategoryId(categoryObject = {}) {
      const { benefit, event, publication, productService } = categoryObject;
      return Object.values({ benefit, event, publication, productService })
        .filter(Boolean)
        .join('');
    },

    async openMenuEvent() {
      await this.ensureRulesCatalogReady();

      if (this.savedRules !== undefined) {
        if (this.hasLoadedSavedRules) {
          if (this.rulesTouched) return;
          this.hasLoadedSavedRules = false;
        }
        this.hasLoadedSavedRules = true;
        const hasRules = Object.keys(this.savedRules).some((key) =>
          key === 'allCategories'
            ? Object.values(this.savedRules[key] || {}).some(Boolean)
            : this.savedRules[key]?.length > 0
        );
        if (this.isExclusiveEventMode) {
          if (!hasRules) {
            this.initializeExclusiveRules();
            return;
          }
          const selectedRules = this.normalizeRules(this.savedRules);
          const allCategories = Object.keys(this.savedRules.allCategories || {}).length > 0
            ? this.normalizeAllCategories(this.savedRules.allCategories)
            : this.getRuleCategories.reduce((result, key) => {
                result[key] = this.categoryIsFullySelected(key, selectedRules);
                return result;
              }, this.normalizeAllCategories());
          this.setRules([], selectedRules, allCategories, false);
          return;
        }
        if (hasRules) {
          const selected_category = Object.keys(this.savedRules).filter(
            (key) =>
              this.savedRules[key].length > 0 &&
              this.savedRules[key].length === this.rules_default[key]?.length
          );
          this.setRules(selected_category, this.savedRules, {}, false);
          return;
        }
        this.setRules([], { memberStatus: ['ACTIVE'] }, {}, false);
        return;
      }

      if (this.hasLoadedSavedRules) {
        if (this.rulesTouched) return;
        this.hasLoadedSavedRules = false;
      }
      this.hasLoadedSavedRules = true;

      const { data: rules, status } = await this.getAudienceRuleByCategoryId(
        this.getCurrentCategoryId(this.$props)
      );

      if (!status) {
        this.setRules([], { memberStatus: ['ACTIVE'] }, {}, false);
        return;
      };

      const selected_category = Object.keys(rules).filter(
        (key) =>
          rules[key].length > 0 &&
          rules[key].length === this.getRuleDefaultValues(key).length
      );

      this.setRules(selected_category, rules, rules.allCategories || {}, false);
    },
  },
  async mounted() {
    await this.ensureRulesCatalogReady();
  },
};
</script>

<style scoped>
.audience-menu-card {
  max-width: calc(100vw - 32px);
  max-height: min(70vh, 500px);
  overflow-y: auto;
  border-radius: 16px !important;
}

.audience-menu-header {
  min-height: 32px;
}

.audience-menu-title {
  color: #1b273e;
  letter-spacing: 0.01em;
}

.audience-categories,
.audience-categories > .v-expansion-panels {
  width: 100%;
}

.audience-category {
  border: 1px solid rgba(27, 39, 62, 0.1);
  border-radius: 10px !important;
  margin-bottom: 8px;
}

.audience-category:last-child {
  margin-bottom: 0;
}

.audience-option {
  min-height: 36px;
}

@media (max-width: 480px) {
  .audience-menu-card {
    max-width: calc(100vw - 24px);
  }
}
</style>
